import flow from 'lodash/flow'

import {authGet, authPut, monolithGet} from './fetch'
import {
  camelCaseObjectKeys,
  shallowOmitKeys,
  onStatus,
  shimJson,
  snakeCaseObjectKeys,
} from './helpers'
import SERVICES from '../config/services'

// ///////////////////////////////
// ///// USER DATA //////////////
// ///////////////////////////////

/*
 * NOTE: This API call will NOT redirect the user to the login page if the JWT
 *  is invalid.
 *
 * {
 *   id,
 *   email,
 *   firstName,
 *   lastName,
 * }
 */
export const getUser = () =>
  // eslint-disable-line import/prefer-default-export
  authGet(`${SERVICES.TBT_API_URL}/users/info`).then(
    onStatus({
      OK: shimJson(flow([camelCaseObjectKeys, (json) => shallowOmitKeys(json, ['fullName'])])),
    }),
  )

// Customer reset password while logged out, requires a token
export const resetUserPassword = (payload) => authPut('/auth/reset', snakeCaseObjectKeys(payload))

// Customer updates email or name
export const updateUserInfo = (userId, payload) =>
  authPut(`${SERVICES.TBT_API_URL}/users/${userId}/info`, snakeCaseObjectKeys(payload)).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )

// Customer updates password while logged in
export const updateUserPassword = (payload) =>
  authPut(`${SERVICES.TBT_API_URL}/auth/change`, snakeCaseObjectKeys(payload))

export const getEligibleRTKItems = ({eventId, userId}) =>
  monolithGet(`/v1/users/${userId}/events/${eventId}/rent-to-keep-items`).then(
    onStatus({OK: shimJson(camelCaseObjectKeys)}),
  )

/**
 * Retrieve a user's itemized account balance information
 *
 * @param {String} userId The user's ID
 * @return {Object} An object containing total account balance and itemized history
 */
export const getAccountBalance = (userId) =>
  monolithGet(`/v1/users/${userId}/account-balance`).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )
